import helpers from '../helpers/helpers';
//import GoogleMaps from '../functions/google_maps'
import { WOW } from 'wowjs/dist/wow';
import Pace from 'imports?jQuery=jquery!pace';


//import style from '../helpers/mapstyle';
export default {
  init() {
    // JavaScript to be fired on all pages
    $('.hidden-block').slideUp(200);
    //GoogleMaps.init()
    this.preloader();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    helpers.svgConversion();
    this.modalOpening();
    this.accordionSlide();
    this.accordions();
    this.navigationOpen();
    this.navSticky();
  },

  preloader() {
    let preloader = $('.preloader');
    $('.preloader').remove();
    Pace.on('start', () => {
      preloader.css({'display':'block'});
      $('.pace-activity').append(preloader);
      $('.pace-activity').css({'transition': 'opacity 0.3s ease-out', 'opacity':'1'});
      $('.shownRight').css({'animation-play-state':'running'});
    });

    Pace.on('done', () => {
      setTimeout(function() {
        $('.wrapper').css({'transition': 'opacity 0.3s ease-out', 'opacity':'1'});
      }, 500);
      new WOW().init({
        boxClass: 'wow',
        mobile: false,
        offset: 100,
        live: false,
      });
    });
    Pace.start();
  },

  navigationOpen() {
    function toggleClassHeaderMenu() {
      $('.header').toggleClass('header--open');
      $('.hamburger').toggleClass('is-active');
    }

    $('.toggle-menu').on('click', toggleClassHeaderMenu)
  },
  navSticky() {
    const mainNav = $('.header');
    let heroSectionHegith;
    setTimeout(function() {heroSectionHegith = $('.hero__wrap').height();}, 200)

    $(window).on('scroll', () => {
      let windowFromTop = $(window).scrollTop();
      if (windowFromTop >= heroSectionHegith - 300) {
        mainNav.addClass('header--fixed');
      } else if (windowFromTop < heroSectionHegith - 300) {
        mainNav.removeClass('header--fixed');
      }
    });
  },
  modalOpening() {
    let modal = $('#modal');
    let closer = $('.modal .closer');
    let overlay = $('.overlay');
    let modalToggle = $('.modal-toggle');
    function openModal(e) {
      e.preventDefault();
      modal.addClass('isShow');
      overlay.addClass('isShow');
    }

    function closerModal(e) {
      e.preventDefault();
      modal.removeClass('isShow');
      overlay.removeClass('isShow');
    }

    modalToggle.on('click', openModal);
    overlay.on('click', closerModal);
    closer.on('click', closerModal);
  },
  accordions() {
    let accordionToggle = $('.accordion h6');
    let allAccrionds = $('.accordion .text-container');
    allAccrionds.slideUp(0);

    function accordionOpenClose(e) {
      e.preventDefault();
      $(this).parents().siblings().removeClass('isOpen').find('.text-container').slideUp(300);
      $(this).parents().toggleClass('isOpen')
      $(this).siblings().slideToggle(300);
    }
    accordionToggle.on('click', accordionOpenClose)
  },
  accordionSlide() {
    let oldValue;
    $('.toggle-accordion').on('click', function(e) {
      e.preventDefault();
      let currentValue = $(this).text();
      let dataValue = $(this).attr('data-showhide');
      if(currentValue != dataValue) {
        $(this).text(dataValue);
        oldValue = currentValue;
      } else {
        $(this).text(oldValue);
      }
      $(this).parent().find('.hidden-block').slideToggle(200)
    })
  }
};




// WEBPACK FOOTER //
// ./scripts/routes/Common.js